import { ReactElement, useEffect, useMemo, useRef } from 'react';
import * as S from './spheres.styled';
import { SpheresModel } from './spheres.model';
import { StaticItemContainer, StaticItemsContainer } from './staticItems';
import { getFastLinksIcons } from '../../../fastLinks.meta';
import { FastLinksIconsEnum } from '../../../fastLinks.model';
import { useDispatch, useSelector } from 'react-redux';
import { getFastLinksMenuStatusSelector } from '../../fastLinksMenu.selectors';
import { Nullable } from '../../../../../models';
import { urlService } from '../../../../../services';
import {
  getFastLinkHref,
  getFastLinksCoursesPath,
} from '../../../fastLinks.helper';
import { useRouter } from 'next/router';
import { openFastLinksMenu } from '../../fastLinksMenu.actions';
import { getAllCoursesStaticItem } from '../../fastLinksMenu.helper';
import { useTranslations } from '../../../../../features';

export const SpheresContainer = ({
  spheres,
  activeSphere,
  handleClickSphere,
  filtersAccentColor,
}: SpheresModel): ReactElement => {
  const router = useRouter();
  const dispatch = useDispatch();
  const translations = useTranslations();
  const coursesPath = getFastLinksCoursesPath(router.query);
  const spheresRef = useRef<Nullable<HTMLDivElement>>(null);
  const { isOpened } = useSelector(getFastLinksMenuStatusSelector);
  const fastLinksIcons = useMemo(
    () => getFastLinksIcons(filtersAccentColor),
    []
  );
  const handleCloseFastLinksMenu = () => {
    dispatch(openFastLinksMenu(false));
  };

  useEffect(() => {
    spheresRef.current?.scroll(0, 0);
  }, [isOpened]);

  return (
    <S.Spheres ref={spheresRef}>
      <S.SpheresItems>
        <StaticItemContainer
          key="all_courses"
          filtersAccentColor={filtersAccentColor}
          {...getAllCoursesStaticItem(router, translations, filtersAccentColor)}
        />
        {spheres.map((item) => (
          <S.SpheresItem
            onClick={handleCloseFastLinksMenu}
            onMouseEnter={handleClickSphere.bind(null, item)}
            isActive={activeSphere.slug === item.slug}
            key={item.slug}
            href={urlService.getFullUrlToPage(
              getFastLinkHref(item.slug, coursesPath),
              router
            )}
          >
            <S.SpheresItemImage>
              {fastLinksIcons[item.slug as keyof typeof FastLinksIconsEnum]}
            </S.SpheresItemImage>
            <S.SpheresItemTitle>{item.title}</S.SpheresItemTitle>
          </S.SpheresItem>
        ))}
      </S.SpheresItems>
      <StaticItemsContainer filtersAccentColor={filtersAccentColor} />
    </S.Spheres>
  );
};
